<div class="container" *ngIf="!paymentVerified">
    <div class="row col-sm-12 mt-5">
        <mat-spinner class="m-auto" [diameter]="70"></mat-spinner>
    </div>
    <div class="row mt-5 mb-5">
        <div class="col-sm-12">
            <p class="text-center">Submitting transaction detail for verification. Please Wait.</p>
        </div>
    </div>
</div>
<div class="container" *ngIf="paymentVerified" [@openClose]="paymentVerified ? 'open' : 'closed'">
    <div class="row mt-5 mb-5">
        <div class="col-sm-12">
            <h1 class="verification-text text-center">Please add Proof of Payment for furthur verification.</h1>
        </div>
        <div class="col-sm-12 image-holder mt-3 mb-3">
            <img *ngIf="!imgURL" src="assets/placeholder-image.png" />
            <img *ngIf="imgURL" [src]="imgURL" />
            <div class="file-chooser">
              <p class="text-center">Proof of Payment</p>
              <input (change)="fileChangeEvent($event)" type="file">
            </div>
        </div>
        <div class="col-sm-12">
            <p class="text-center"><button (click)="viewProperty()" class="theme-button" mat-raised-button>View Property</button></p>
        </div>
    </div>
</div>